module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XI",
      "role": "doc-pagebreak",
      "title": "XI"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "pre1_1",
      "src": "images/pre1.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("Author’s Preface")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("I HAVE ALWAYS BEEN")]), _vm._v(" a big picture kind of person. This book gave me the opportunity to explore the big picture of the Bible, beginning at creation and ending at the new creation. I resonate with the practice and provision of biblical theology and was honored to contribute this book to the Essential Studies in Biblical Theology series. In one sense, biblical theology is the practice of reading the big picture of the Bible. Definitions of and debates about biblical theology abound, but it is maybe best viewed from the perspective of the church as seeing the big picture of God’s person, provision, and purposes for his people and the world. No book can cover all of that, but I hope in regard to the theme of creation and new creation that I have presented accurately what God wants to say to—and is doing for—his people and the world.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I wrote the last few chapters of this book, chapters that explore the glorious renewal of all creation, as my mom was battling for her life after a serious cancer surgery. In fact, in one of our most recent conversations I shared with her some of what I wrote to you, the readers, in this book—the beautiful story of God’s creation project. As a biblical theologian, my goal in this book is to explain what the theme of creation and new creation reveals about God "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XII",
      "role": "doc-pagebreak",
      "title": "XII"
    }
  }, [_vm._v("and his purposes for the world, which he unveiled progressively throughout the biblical story. And as a pastor, my hope is that this book helps explain the goodness and grace of God that began when he first spoke the world into existence and will one day be perfectly accomplished in the new creation of the heavens and the earth. But as a Christian, this book confesses my confidence and hope in the new creation and the glorious fact that my mom, Kimberly Grace Klink, will one day have a resurrected body, and that she and I will have sweet fellowship in the presence of our gracious God.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Every book I have written is only possible because of the gracious provisions of so many people. I continue to be grateful to the beautiful people at Hope Evangelical Free Church in Roscoe, Illinois, where I serve as senior pastor. I am indebted to my fellow pastor-elders, who empower me to serve as a pastor theologian through my writing, as well as a wonderful staff team that is a delight in every way. My family are constant supporters and encouragers, and none of this would be possible without their provision and permission. My thanks to my three children, Jacob, Benjamin, and Ruth, for loving (and teasing) their book-loving dad. And to Laura, my wife, without whom not one page of this book would have been written. I am honored to publish this book with InterVarsity Press and owe my thanks to the series editor, Benjamin Gladd, for his invitation and contribution to this book. I am also thankful for the editorial team at InterVarsity Press for all their help in its production.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book is dedicated to Fana Timoti. I may be (primarily) German and he may be Samoan, but we are brothers in every other way—and in the most important way, in the Lord. You, Elizabeth, and your whole family are our family and have been so since we first met. You have encouraged me as a theologian, a pastor, a dad, and a Christian. You are a gift to Laura and me and an uncle to my children. Our friendship in Christ is itself a symptom of the inauguration of the new creation, when “persons from every tribe and language and people and nation,” Germans and Samoans included, will sing a new song to the Lord, saying, “Worthy is the Lamb . . . to receive . . . honor and glory and praise” (Rev 5:9, 12).")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0